/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PianoAssenzeGiornoDTO } from './PianoAssenzeGiornoDTO';
import {
    PianoAssenzeGiornoDTOFromJSON,
    PianoAssenzeGiornoDTOFromJSONTyped,
    PianoAssenzeGiornoDTOToJSON,
    PianoAssenzeGiornoDTOToJSONTyped,
} from './PianoAssenzeGiornoDTO';

/**
 * 
 * @export
 * @interface PianoAssenzeDTO
 */
export interface PianoAssenzeDTO {
    /**
     * 
     * @type {number}
     * @memberof PianoAssenzeDTO
     */
    idPersonale?: number;
    /**
     * 
     * @type {string}
     * @memberof PianoAssenzeDTO
     */
    nominativo?: string | null;
    /**
     * 
     * @type {Array<PianoAssenzeGiornoDTO>}
     * @memberof PianoAssenzeDTO
     */
    giorni?: Array<PianoAssenzeGiornoDTO> | null;
}

/**
 * Check if a given object implements the PianoAssenzeDTO interface.
 */
export function instanceOfPianoAssenzeDTO(value: object): value is PianoAssenzeDTO {
    return true;
}

export function PianoAssenzeDTOFromJSON(json: any): PianoAssenzeDTO {
    return PianoAssenzeDTOFromJSONTyped(json, false);
}

export function PianoAssenzeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PianoAssenzeDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idPersonale': json['idPersonale'] == null ? undefined : json['idPersonale'],
        'nominativo': json['nominativo'] == null ? undefined : json['nominativo'],
        'giorni': json['giorni'] == null ? undefined : ((json['giorni'] as Array<any>).map(PianoAssenzeGiornoDTOFromJSON)),
    };
}

export function PianoAssenzeDTOToJSON(json: any): PianoAssenzeDTO {
    return PianoAssenzeDTOToJSONTyped(json, false);
}

export function PianoAssenzeDTOToJSONTyped(value?: PianoAssenzeDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idPersonale': value['idPersonale'],
        'nominativo': value['nominativo'],
        'giorni': value['giorni'] == null ? undefined : ((value['giorni'] as Array<any>).map(PianoAssenzeGiornoDTOToJSON)),
    };
}

